import ScrollPanel from './ScrollPanel.vue';

ScrollPanel.install = (Vue) => {
  Vue.component(ScrollPanel.name, ScrollPanel);
};

export default ScrollPanel;
